import React from "react";
export default (props) => (React.createElement("li", { className: `timeline-item ${props.isActive ? "is-active" : ""} ${props.isInbetweenStepActive ? "is-stepped" : ""}` },
    React.createElement("div", { className: "timeline-indicator" }),
    React.createElement("div", { className: "timeline-label" }, props.label)));
